export const convertObjToQuery = <T extends object>(data: T): string => {
  let result = ""
  for(const item in data) {
    if(data[item] !== undefined) {
      result+= `${item}=${data[item]}&`
    }
  }

  return result
}